// Shared site configuration options used by the public site and the admin editor.

// Each option: [displayLabel, googleFontFamily]
export const SERIF_FONTS = [
  ['Cormorant Garamond (défaut)', 'Cormorant Garamond'],
  ['Playfair Display', 'Playfair Display'],
  ['EB Garamond', 'EB Garamond'],
  ['Cormorant', 'Cormorant'],
  ['Libre Baskerville', 'Libre Baskerville'],
  ['Marcellus', 'Marcellus'],
  ['Italiana', 'Italiana'],
];

export const SANS_FONTS = [
  ['Jost (défaut)', 'Jost'],
  ['Montserrat', 'Montserrat'],
  ['Poppins', 'Poppins'],
  ['Raleway', 'Raleway'],
  ['Lato', 'Lato'],
  ['Inter', 'Inter'],
  ['Work Sans', 'Work Sans'],
];

// Build a Google Fonts stylesheet URL for the chosen families.
export function googleFontsUrl(heading, body) {
  const families = new Set();
  if (heading) families.add(`${heading.replace(/ /g, '+')}:ital,wght@0,400;0,500;0,600;1,400;1,500`);
  if (body) families.add(`${body.replace(/ /g, '+')}:wght@300;400;500`);
  const params = [...families].map((f) => `family=${f}`).join('&');
  return `https://fonts.googleapis.com/css2?${params}&display=swap`;
}

// Convert a YouTube URL (watch, youtu.be, embed) into an embeddable URL.
export function youtubeEmbed(url) {
  if (!url) return '';
  try {
    const u = new URL(url);
    let id = '';
    if (u.hostname.includes('youtu.be')) id = u.pathname.slice(1);
    else if (u.searchParams.get('v')) id = u.searchParams.get('v');
    else if (u.pathname.includes('/embed/')) id = u.pathname.split('/embed/')[1];
    id = (id || '').split('&')[0].split('?')[0];
    return id ? `https://www.youtube.com/embed/${id}` : '';
  } catch {
    return '';
  }
}
